// extracted by mini-css-extract-plugin
module.exports = {"counter":"PkhNF","counterMemberArea":"_3zpFi","viewCount":"awYZ6","commentCount":"_2QTXH"};